export function filterToggleClose() {
    $(".open-filter").click(function () {
        $(this).removeClass("d-block");
        $(this).addClass("d-none");
        $(this).next().removeClass("d-none");
        $(this).next().addClass("d-block");
        $(".left-sidebar-mobile-container").removeClass("d-none");
        $(".left-sidebar-mobile-container").addClass("d-block")
    });
    $(".close-filter").click(function () {
        $(this).removeClass("d-block");
        $(this).addClass("d-none");
        $(this).prev().removeClass("d-none");
        $(this).prev().addClass("d-block");
        $(".left-sidebar-mobile-container").removeClass("d-block");
        $(".left-sidebar-mobile-container").addClass("d-none")
    });
}